import { Lock, KeyRound, Mail, Package, ScanLine } from "lucide-react";

// Decorative, fixed, non-interactive page atmosphere. Sits behind page content (which must be `relative z-10`).
// `image` = supplied reference art anchored to one side; `motif` = light CSS/SVG detail for pages without art.
export const DnaHelix = ({ className = "", flip = false }) => (
  <svg
    viewBox="0 0 120 900" preserveAspectRatio="none" aria-hidden
    className={`bl-dna ${flip ? "bl-dna-flip" : ""} ${className}`}
  >
    <defs>
      <linearGradient id="bl-dna-g" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stopColor="rgba(76,157,255,0)" />
        <stop offset="0.2" stopColor="rgba(76,157,255,0.9)" />
        <stop offset="0.8" stopColor="rgba(56,210,255,0.9)" />
        <stop offset="1" stopColor="rgba(56,210,255,0)" />
      </linearGradient>
    </defs>
    <g stroke="url(#bl-dna-g)" fill="none" strokeWidth="1.4">
      <path d="M20 0 C110 110, 10 220, 100 330 S10 550, 100 660 S10 880, 100 900" />
      <path d="M100 0 C10 110, 110 220, 20 330 S110 550, 20 660 S110 880, 20 900" />
      {Array.from({ length: 27 }).map((_, i) => {
        const y = 15 + i * 33;
        const t = Math.sin((y / 900) * Math.PI * 6);
        const x1 = 60 - 40 * t, x2 = 60 + 40 * t;
        return <line key={`rung-${y}`} x1={x1} y1={y} x2={x2} y2={y} opacity={0.35 + 0.35 * Math.abs(t)} />;
      })}
    </g>
    <g fill="rgba(120,200,255,0.9)">
      {Array.from({ length: 27 }).map((_, i) => {
        const y = 15 + i * 33;
        const t = Math.sin((y / 900) * Math.PI * 6);
        return <circle key={`node-${y}`} cx={60 - 40 * t} cy={y} r="1.8" />;
      })}
    </g>
  </svg>
);

const MOTIF_ICON = { privacy: [Lock, KeyRound], contact: [Mail], track: [Package, ScanLine] };

export default function PageBackdrop({ image, align = "right", dim = 0.55, motif, helix = true, className = "" }) {
  const icons = MOTIF_ICON[motif] || [];
  return (
    <div className={`bl-backdrop ${className}`} aria-hidden data-testid="page-backdrop">
      {image && (
        <img
          src={image} alt=""
          className={`bl-backdrop-img bl-backdrop-${align}`}
          loading="eager" decoding="async"
        />
      )}
      <div className="bl-backdrop-veil" style={{ "--bl-veil": dim }} />
      {helix && (
        <>
          <DnaHelix className={`bl-dna-a ${image ? "bl-dna-soft" : ""}`} />
          {!image && <DnaHelix flip className="bl-dna-b" />}
        </>
      )}
      {icons.length > 0 && (
        <div className="bl-motif-icons">
          {icons.map((Icon, i) => (
            <Icon key={Icon.displayName || Icon.name || i} strokeWidth={0.7} className={`bl-motif-icon bl-motif-icon-${i}`} />
          ))}
        </div>
      )}
      <div className="bl-backdrop-grain" />
    </div>
  );
}
